import SectionHeading from '@/components/base/SectionHeading';
import { testimonials } from '@/mocks/home';

export default function VoicesSection() {
  return (
    <section id="voices" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="网站口碑"
          title="读者怎么说"
          desc="这份攻略来自长期围观热点的普通读者，也服务于同样喜欢看热闹的你。下面是部分读者的真实反馈。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((voice) => (
            <figure
              key={voice.name}
              className="flex flex-col rounded-lg border border-background-200/80 bg-background-100/60 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-400" aria-hidden="true"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {voice.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/80 pt-4">
                <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full">
                  <img
                    src={voice.avatar}
                    alt={`读者${voice.name}的头像`}
                    className="h-full w-full object-cover object-top"
                  />
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="font-heading text-sm font-bold text-foreground-950">{voice.name}</span>
                  <span className="mt-0.5 font-label text-xs text-foreground-500">{voice.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}